<template>
  <div>
    <el-card>
      <el-select
        v-model="userDataValue"
        placeholder="请选择身份"
        class="m-r"
        @change="onChangeUserData"
      >
        <el-option
          v-for="item in userData"
          :key="item.Name"
          :label="item.Name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="moduleDataValue"
        placeholder="请选择模块"
        class="m-r"
        @visible-change="GetAdminCateInfo"
      >
        <el-option
          v-for="item in moduleData"
          :key="item.Name"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="functionDataValue"
        placeholder="请选择功能"
        class="m-r"
        @visible-change="GetAdminCateInfoFunction"
      >
        <el-option
          v-for="item in functionData"
          :key="item.Name"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-select v-model="statuDataValue" placeholder="请选择状态" class="m-r">
        <el-option
          v-for="item in statuData"
          :key="item.Name"
          :label="item.Name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select v-model="familiarValue" placeholder="是否常见" class="m-r">
        <el-option
          v-for="item in familiar"
          :key="item.Name"
          :label="item.Name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="input"
        placeholder="请输入关键词"
        style="width: 200px"
        class="m-r"
      ></el-input>
      <el-button type="goon" @click="GetCS_CateByPage">查询</el-button>
      <el-button type="goon" @click="onClickDeleteData">清空</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-button type="goon" @click="onClickAdd">新增</el-button>
      <el-button type="goon" @click="dialogVisibleImport = true"
        >批量导入</el-button
      >
      <el-button type="goon" @click="onClickDown">模板下载</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column label="序号" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="IdentityName" label="身份" align="center">
        </el-table-column>
        <el-table-column prop="OneName" label="模块" align="center">
        </el-table-column>
        <el-table-column prop="TwoName" label="功能" align="center">
        </el-table-column>
        <el-table-column prop="Question" label="问题Q" align="center">
        </el-table-column>
        <el-table-column prop="Answer" label="回答A" align="center">
        </el-table-column>
        <el-table-column prop="KeyWords" label="关键词" align="center">
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-switch
              @change="onChangeSwitch($event, scope.row)"
              v-model="scope.row.Status"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="ModifyTime" label="最后修改时间" align="center">
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: #4083fe"
              @click="onClickEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="onClickDeleteTabs(scope.row)"
              style="color: #e14747"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="PageSize"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form ref="formInline" :model="form">
          <el-form-item label="身份：">
            <el-select
              v-model="form.userDataValue"
              multiple
              placeholder="请选择身份"
            >
              <el-option
                v-for="item in userData"
                :key="item.Name"
                :label="item.Name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模块：">
            <el-select
              v-model="form.moduleDataValue"
              placeholder="请选择模块"
              class="m-r"
              @visible-change="GetAdminCateInfo"
            >
              <el-option
                v-for="item in moduleData"
                :key="item.Name"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="功能：">
            <el-select
              v-model="form.functionDataValue"
              placeholder="请选择功能"
              class="m-r"
              @visible-change="GetAdminCateInfoFunction"
            >
              <el-option
                v-for="item in functionData"
                :key="item.Name"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select
              v-model="form.statuDataValue"
              placeholder="请选择状态"
              class="m-r"
            >
              <el-option
                v-for="item in statuData"
                :key="item.Name"
                :label="item.Name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否常见：">
            <el-select
              v-model="form.familiarValue"
              placeholder="是否常见"
              class="m-r"
            >
              <el-option
                v-for="item in familiar"
                :key="item.Name"
                :label="item.Name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题：">
            <el-input type="textarea" v-model="form.question"></el-input>
          </el-form-item>
          <el-form-item label="回答：">
            <el-input type="textarea" v-model="form.answer"></el-input>
          </el-form-item>
          <el-form-item label="关键词：">
            <div class="flex-items">
              <el-input
                type="text"
                style="width: 200px"
                oninput="value=value.replace(/\s+/g,'')"
                v-model="KeyWords"
              ></el-input>
              <i
                class="el-icon-circle-plus-outline"
                style="font-size: 30px; margin-left: 20px"
                @click="onClickKeyWords"
              ></i>
            </div>
          </el-form-item>
          <el-form-item label="关键词内容：" v-if="form.KeyWords.length != 0">
            <div class="flex" style="flex-wrap: wrap">
              <div
                class="tui-borders flex-center"
                v-for="(item, index) in form.KeyWords"
                :key="item"
              >
                {{ item }}
                <div
                  class="tui-bordersStatus el-icon-error"
                  @click="onClickDelete(index)"
                ></div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="Title == '编辑' ? editSubmit() : AddCs_Question()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="dialogVisibleImport">
      <el-upload
        class="image-uploader"
        :multiple="false"
        :auto-upload="true"
        list-type="excel"
        :show-file-list="true"
        :drag="true"
        action
        :limit="1"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :http-request="uploadFile"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          一次只能上传一个文件，仅限excel格式，单文件不超过5MB
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleImport = false">取消</el-button>
        <el-button type="primary" @click="ImportStudent">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetAdminCateInfo,
  GetCS_CateByPage,
  AddCs_Question,
  DeleteCs_QuestionInfo,
  UpdateAddCs_Question,
  OpenCloseCs_QuestionInfo,
  Cs_QuestionImportMyQuestionCategoryInfo,
  FileUploadsExcel,
} from "../../api/api";
export default {
  data() {
    return {
      input: "",
      tableData: [],
      dialogVisible: false,
      Title: "新增",
      form: {
        moduleDataValue: null,
        userDataValue: null,
        functionDataValue: null,
        statuDataValue: null,
        familiarValue: null,
        question: "",
        answer: "",
        KeyWords: [],
      },
      userData: [
        {
          Name: "园长",
          id: 1,
        },
        {
          Name: "教师",
          id: 2,
        },
        {
          Name: "家长",
          id: 3,
        },
      ],
      userDataValue: null,
      statuData: [
        {
          Name: "开启",
          id: 1,
        },
        {
          Name: "关闭",
          id: 0,
        },
      ],
      statuDataValue: null,
      familiar: [
        {
          Name: "是",
          id: 1,
        },
        {
          Name: "否",
          id: 0,
        },
      ],
      familiarValue: null,
      moduleData: [],
      moduleDataValue: null,
      functionData: [],
      functionDataValue: null,
      total: 0,
      PageSize: 10,
      PageIndex: 1,
      KeyWords: "",
      dialogVisibleImport: false,
      excelurl: "",
    };
  },
  created() {
    this.GetCS_CateByPage();
  },
  methods: {
    onClickAdd() {
      this.form = {
        moduleDataValue: null,
        userDataValue: null,
        functionDataValue: null,
        statuDataValue: null,
        familiarValue: null,
        question: "",
        answer: "",
        KeyWords: [],
      };
      this.dialogVisible = true;
    },
    onClickDeleteData() {
      this.userDataValue = null;
      this.moduleDataValue = null;
      this.moduleData = [];
      this.functionData = [];
      this.functionDataValue = null;
      this.statuDataValue = null;
      this.familiarValue = null;
      this.input = "";
      this.GetCS_CateByPage();
    },
    onClickDown() {
      location.href =
        "http://mushroomisland.cn/exceldown/客服问题导入模版.xlsx";
    },
    //上传文件
    ImportStudent() {
      if (this.excelurl) {
        Cs_QuestionImportMyQuestionCategoryInfo({
          excelurl: this.excelurl,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            //初始化数据
            this.dialogVisibleImport = false;
            this.GetCS_CateByPage();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    //导入
    uploadFile(item) {
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      FileUploadsExcel(form).then((res) => {
        //console.log(res, "aaaaaaaaa");
        this.excelurl = res.data.url;
        // //console.log(response);
        // //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      return isText | isTextComputer;
    },
    // 编辑确定
    async editSubmit() {
      let res = await UpdateAddCs_Question({
        Id: this.form.Id,
        userIdentity: this.form.userDataValue.join(","),
        pId: this.form.functionDataValue,
        question: this.form.question,
        answer: this.form.answer,
        status: this.form.statuDataValue ? this.form.statuDataValue : -1,
        isRecommend: this.form.familiarValue ? this.form.familiarValue : -1,
        KeyWords: this.form.KeyWords,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "编辑成功",
        });
        this.GetCS_CateByPage();
        this.dialogVisible = false;
        this.setData();
      } else {
        this.$message({
          type: "error",
          message: "编辑失败",
        });
      }
    },
    async onChangeSwitch(e, item) {
      let res = await OpenCloseCs_QuestionInfo({ ids: [item.Id], status: e });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.GetCS_CateByPage();
      } else {
        this.$message({
          type: "error",
          message: "操作失败!",
        });
      }
    },
    // 编辑
    async onClickEdit(item) {
      let arr = item.IdentityId.split(",").map(Number);
      //console.log(arr);
      this.Title = "编辑";
      this.form = {
        Id: item.Id,
        moduleDataValue: item.OneId,
        userDataValue: arr,
        functionDataValue: item.TwoId,
        statuDataValue: item.Status,
        familiarValue: item.IsRecommend,
        question: item.Question,
        answer: item.Answer,
        KeyWords: item.KeyWords.split("、"),
      };
      this.dialogVisible = true;
      this.GetAdminCateInfo();
      this.GetAdminCateInfoFunction();
      //console.log(this.form);
    },
    // 删除
    async onClickDeleteTabs(row) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteCs_QuestionInfo({ ids: [row.Id] });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetCS_CateByPage();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    setData() {
      this.form = {
        moduleDataValue: null,
        userDataValue: null,
        functionDataValue: null,
        statuDataValue: null,
        familiarValue: null,
        question: "",
        answer: "",
        KeyWords: [],
      };
    },
    // 关键词新增
    onClickKeyWords() {
      if (this.KeyWords != "") {
        this.form.KeyWords.push(this.KeyWords);
        this.KeyWords = "";
      }
    },
    onClickDelete(index) {
      this.form.KeyWords.splice(index, 1);
    },
    // 新增
    async AddCs_Question() {
      // moduleDataValue: null,
      //   userDataValue: null,
      //   functionDataValue: null,
      //   statuDataValue: null,
      //   familiarValue: null,
      //   question: "",
      //   answer: "",
      //   KeyWords: [],
      //console.log(this.form);
      if (
        this.form.moduleDataValue &&
        this.form.userDataValue.length != 0 &&
        this.form.functionDataValue &&
        this.form.statuDataValue &&
        this.form.familiarValue &&
        this.form.question != "" &&
        this.form.answer != "" &&
        this.form.KeyWords.length != 0
      ) {
        let res = await AddCs_Question({
          userIdentity: this.form.userDataValue.join(","),
          pId: this.form.functionDataValue,
          question: this.form.question,
          answer: this.form.answer,
          status: this.form.statuDataValue ? this.form.statuDataValue : -1,
          isRecommend: this.form.familiarValue ? this.form.familiarValue : -1,
          KeyWords: this.form.KeyWords,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "新增成功",
          });
          this.GetCS_CateByPage();
          this.dialogVisible = false;
          this.setData();
        } else {
          this.$message({
            type: "error",
            message: "新增失败",
          });
        }
      } else {
        this.$message({
          type: "error",
          message: "请填写对应的选项",
        });
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetCS_CateByPage();
    },
    // 获取问题列表
    async GetCS_CateByPage() {
      let res = await GetCS_CateByPage({
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        userIdentity: this.userDataValue ? this.userDataValue : -1,
        oneId: this.moduleDataValue,
        twoId: this.functionDataValue,
        status: this.statuDataValue ? this.statuDataValue : -1,
        keyWords: this.input,
        IsRecommend: this.familiarValue ? this.familiarValue : -1,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async onChangeUserData() {
      await this.GetAdminCateInfo();
      await this.GetAdminCateInfoFunction();
    },
    // 获取后台分类
    async GetAdminCateInfo() {
      let UserIdentity;
      if (this.dialogVisible) {
        UserIdentity = this.form.userDataValue[0]
          ? this.form.userDataValue[0]
          : -1;
      } else {
        UserIdentity = this.userDataValue ? this.userDataValue : -1;
      }
      let res = await GetAdminCateInfo({
        UserIdentity: UserIdentity,
      });
      if (res.data.success) {
        this.moduleData = res.data.response;
      } else {
        this.moduleData = [];
        this.moduleDataValue = null;
      }
    },
    // 获取功能
    async GetAdminCateInfoFunction() {
      let UserIdentity;
      let ParentId;
      if (this.dialogVisible) {
        UserIdentity = this.form.userDataValue[0]
          ? this.form.userDataValue[0]
          : -1;
        ParentId = this.form.moduleDataValue;
      } else {
        UserIdentity = this.userDataValue ? this.userDataValue : -1;
        ParentId = this.moduleDataValue;
      }
      let res = await GetAdminCateInfo({
        UserIdentity: UserIdentity,
        ParentId: ParentId,
      });
      if (res.data.success) {
        this.functionData = res.data.response;
      } else {
        this.functionData = [];
        this.functionDataValue = null;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.m-r {
  margin-right: 20px;
  margin-bottom: 20px;
}
.tui-borders {
  padding: 0 20px;
  height: 30px;
  border-radius: 3px;
  border: 1px solid #cdcdcd;
  font-size: 16px;
  color: #999999;
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
  .tui-bordersStatus {
    position: absolute;
    right: 0;
    top: 0;
  }
}
.tui-borders:last-child {
  margin-right: 0;
}
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
</style>